import {Fragment, PureComponent} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {
  Collapse,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar as NavbarReactstrap,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  UncontrolledDropdown
} from 'reactstrap'
import {Link, withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'

import ContactUsSmall from '../../components/ContactUs/ContactUsSmall.jsx'
import LoggedContent from './components/LoggedContent.jsx'
import Notifications from '../../components/Notifications/Notifications.jsx'
// import UniverseLoader from '../../components/UniverseLoader/UniverseLoader.jsx';

import actions from './actions.js'
import {generate} from '../../routes.js'
import {getLandingRouteNameForUser, isUserDo, isUserFreelance} from '../../../shared/services/userService.js'

import './Navbar.scss'

import LogoText from '../../media/svg/logo-twineeds.svg'

class Navbar extends PureComponent {
  constructor(props) {
    super(props)

    this.props.displayNavbar(true)
    this.props.setLocked(props.locked)
    this.props.setFixed(props.fixed)

    this.state = {
      isOpen: false,
      aboutDropdownIsOpen: false,
      companyDropdownIsOpen: false,
      freelanceDropdownIsOpen: false,
    }
  }

  static propTypes = {
    className: PropTypes.string,
    contained: PropTypes.bool,
    currentUser: PropTypes.object,
    fixed: PropTypes.bool,
    loading: PropTypes.bool,
    isInternal: PropTypes.bool,
    isUserConnected: PropTypes.bool,
    locked: PropTypes.bool,
    universes: PropTypes.array,
    isUserDo: PropTypes.bool,
    isUserFreelance: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    contained: true,
    locked: false,
    fixed: false
  }

  componentDidMount() {
    this.body = document.getElementsByTagName('body')[0]
    this.updateBodyClasses(this.props.fixed, this.props.locked)
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.fixed !== prevProps.fixed || this.props.locked !== prevProps.locked) {
      this.updateBodyClasses(this.props.fixed, this.props.locked)
    }
    if (this.props.locked && !prevProps.locked) {
      this.props.displayNavbar(true)
    }
    if (this.props.fixed !== prevProps.fixed) {
      this.props.setFixed(this.props.fixed)
    }
    if (this.props.locked !== prevProps.locked) {
      this.props.setLocked(this.props.locked)
    }
  }

  componentWillUnmount() {
    this.updateBodyClasses(false, false)
    this.body = null
  }

  updateBodyClasses(fixed, locked) {
    if (fixed) {
      this.body.classList.add('navbar-fixed')
    } else {
      this.body.classList.remove('navbar-fixed')
    }
    if (locked) {
      this.body.classList.add('navbar-locked')
    } else {
      this.body.classList.remove('navbar-locked')
    }
  }

  toggle = () => {
    this.setState({isOpen: !this.state.isOpen})
  }

  toggleCompanyDropdown = () => {
    this.setState({companyDropdownIsOpen: !this.state.companyDropdownIsOpen})
  }

  toggleFreelanceDropdown = () => {
    this.setState({freelanceDropdownIsOpen: !this.state.freelanceDropdownIsOpen})
  }

  toggleAboutDropdown = () => {
    this.setState({aboutDropdownIsOpen: !this.state.aboutDropdownIsOpen})
  }

  renderContainer = (content) => {
    return this.props.contained ? <div className="container">{content}</div> : <Fragment>{content}</Fragment>
  }

  renderContent = () => {
    const {currentUser, isInternal, isUserConnected, isUserDo, isUserFreelance, search, location} = this.props

    const navbarContent = <Fragment>
      <hr className="d-lg-none"/>
      {this.props.isUserConnected
        ? <LoggedContent currentUser={currentUser} search={search}/>
        : <NavItem>
          <Link
            className="btn btn-outline-secondary ml-xl-5"
            to={{
              pathname: '/login',
              state: {redirectTo: location.pathname}
            }}
          >
            Se connecter
          </Link>
        </NavItem>
      }
    </Fragment>

    const logoRouteName = getLandingRouteNameForUser(currentUser) || 'homepage'

    return <Fragment>
      <div className="d-flex align-items-center">
        <NavbarBrand tag={Link} to={generate({name: logoRouteName})}>
          <div className="logo d-flex">
            <LogoText/>
          </div>
        </NavbarBrand>
        {/*{isUserConnected && currentUser.isMultiverse ? <UniverseLoader/> : ''}*/}
      </div>
      <div className="d-flex flex-lg-row-reverse navbar-container align-items-center">
        {
          isUserConnected &&
          (isUserFreelance || isInternal) ?
            <Notifications/> : ''
        }

        <ContactUsSmall/>

        <NavbarToggler onClick={this.toggle} className="mr-md-2"/>

        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            {(!currentUser || isUserDo) ?
              <Fragment>
                <NavItem className="d-block d-lg-none">
                  <Link className="nav-link title" to={generate({name: 'landing-company'})}>Entreprises</Link>
                </NavItem>
                {this.props.universes.map(universe => (
                  <NavItem className="d-block d-lg-none" key={universe.id}>
                    <Link className="nav-link" to={generate({name: 'landing-company-' + universe.code})}>
                      {universe.name}
                    </Link>
                  </NavItem>
                ))}
                <UncontrolledDropdown
                  className="d-none d-lg-block"
                  isOpen={this.state.companyDropdownIsOpen}
                  onMouseEnter={this.toggleCompanyDropdown}
                  onMouseLeave={this.toggleCompanyDropdown}
                >
                  <DropdownToggle caret color="link" tag="span">
                    <Link className="nav-link" to={generate({name: 'landing-company'})}>Entreprises</Link>
                  </DropdownToggle>
                  <DropdownMenu right tag="ul">
                    {this.props.universes.map(universe => (
                      <li className="nav-item" key={universe.id}>
                        <Link className="dropdown-item" to={generate({name: 'landing-company-' + universe.code})}>
                          {universe.name}
                        </Link>
                      </li>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Fragment> : ''
            }

            {(!currentUser || isUserFreelance) ?
              <Fragment>

                {/* Mobile */}
                <NavItem className="d-block d-lg-none mt-2 mt-md-0 ">
                  <Link className="nav-link title" to={generate({name: 'landing-freelance'})}>
                    Consultants
                  </Link>
                </NavItem>

                {this.props.universes.map(universe => (
                  <NavItem className="d-block d-lg-none" key={universe.id}>
                    <Link className="nav-link" to={generate({name: 'landing-freelance-' + universe.code})}>
                      {universe.name}
                    </Link>
                  </NavItem>
                ))}
                <NavItem className="d-block d-lg-none">
                  <Link className="nav-link" to={generate({name: 'partnerships'})}>Nos partenaires</Link>
                </NavItem>

                {/* Desktop */}

                <UncontrolledDropdown
                  className="d-none d-lg-block"
                  isOpen={this.state.freelanceDropdownIsOpen}
                  onMouseEnter={this.toggleFreelanceDropdown}
                  onMouseLeave={this.toggleFreelanceDropdown}
                >
                  <DropdownToggle caret color="link" tag="span">
                    <Link className="nav-link" to={generate({name: 'landing-freelance'})}>
                      Consultants
                    </Link>
                  </DropdownToggle>
                  <DropdownMenu right tag="ul">
                    {this.props.universes.map(universe => (
                      <li className="nav-item" key={universe.id}>
                        <Link className="dropdown-item" to={generate({name: 'landing-freelance-' + universe.code})}>
                          {universe.name}
                        </Link>
                      </li>
                    ))}
                    <li className="nav-item">
                      <Link className="dropdown-item" to={generate({name: 'partnerships'})}>Nos partenaires</Link>
                    </li>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Fragment> : ''
            }

            <NavItem className="d-block d-lg-none mt-2 mt-md-0">
              <Link className="nav-link title" to={generate({name: 'landing-company'})}>À propos</Link>
            </NavItem>
            <NavItem className="d-block d-lg-none">
              <Link className="nav-link" to={generate({name: 'press'})}>Presse</Link>
            </NavItem>
            <NavItem className="d-block d-lg-none">
              <Link className="nav-link" to={generate({name: 'our-vision'})}>Notre vision</Link>
            </NavItem>
            <NavItem className="d-block d-lg-none">
              <Link className="nav-link" to={generate({name: 'our-videos'})}>Nos vidéos</Link>
            </NavItem>
            <NavItem className="d-block d-lg-none">
              <Link className="nav-link" to={generate({name: 'blog'})}>Blog</Link>
            </NavItem>

            <UncontrolledDropdown
              className="d-none d-lg-block"
              isOpen={this.state.aboutDropdownIsOpen}
              onMouseEnter={this.toggleAboutDropdown}
              onMouseLeave={this.toggleAboutDropdown}
            >
              <DropdownToggle caret color="link" tag="span">À propos</DropdownToggle>
              <DropdownMenu right tag="ul">
                <Link className="dropdown-item" to={generate({name: 'press'})}>Presse</Link>
                <Link className="dropdown-item" to={generate({name: 'our-vision'})}>Notre vision</Link>
                <Link className="dropdown-item" to={generate({name: 'our-videos'})}>Nos vidéos</Link>
                <Link className="dropdown-item" to={generate({name: 'blog'})}>Blog</Link>
              </DropdownMenu>
            </UncontrolledDropdown>

            <NavItem className="mt-2 mt-md-0">
              <Link className="nav-link title text-color-primary mr-xl-5" to={generate({name: 'bring-business'})}>
                Apport d'affaires
              </Link>
            </NavItem>

            {!this.props.loading && currentUser && !currentUser.complete && (<NavItem className="mt-2 mt-md-0">
              <Link to={generate({name: 'create-freelance'})} className="nav-link">
                Finaliser mon inscription
              </Link>
            </NavItem>)}
            {!this.props.loading && navbarContent}
          </Nav>
        </Collapse>
      </div>
    </Fragment>
  }

  render() {
    const classNames = this.props.className !== '' ? [this.props.className] : []
    if (this.props.fixed) {
      classNames.push('fixed')
    }
    if (this.props.visible) {
      classNames.push('visible')
    }

    return (
      <Fragment>
        <NavbarReactstrap color="white" expand="lg" light className={classNames.join(' ')}>
          {this.renderContainer(this.renderContent())}
        </NavbarReactstrap>
        {this.props.children &&
          <div className={`navbar-ext d-flex ${this.props.className}`}>{this.props.children}</div>
        }
      </Fragment>
    )
  }
}

export default connect(
  state => ({
    currentUser: state.currentUser.user,
    isInternal: state.currentUser.user?.isInternal,
    isUserConnected: !!state.currentUser.user?.id,
    loading: !!state.currentUser.loading,
    universes: state.universe.universes,
    visible: state.navbar.visible,
    isUserDo: isUserDo(state.currentUser.user),
    isUserFreelance: isUserFreelance(state.currentUser.user),
  }),
  (dispatch) => bindActionCreators(actions, dispatch)
)(withRouter(Navbar))
